/** @jsx jsx */
/** @jsxRuntime classic */

import {jsx} from "@emotion/core";
import React, {PropsWithChildren} from "react";

export type CellOptions = {
  boldText?: boolean;
  greyText?: boolean;
  noPaddingLeft?: boolean;
  buttonCell?: boolean;
  placeholder?: boolean;
  overflowVisible?: boolean;
};

export type CellProps = {
  text?: string;
  options?: CellOptions;
  style?: React.CSSProperties;
  backgroundColour?: string;
};

const Cell: React.FC<PropsWithChildren<CellProps>> = ({
                                                        children,
                                                        text,
                                                        options,
                                                        style,
                                                        backgroundColour,
                                                      }) => {
  const getCellClassName = () => {
    let className = "Cell";
    if (options) {
      const {
        boldText,
        greyText,
        noPaddingLeft,
        buttonCell,
        placeholder,
        overflowVisible,
      } = options;
      if (boldText) {
        className += " BoldText";
      }
      if (greyText) {
        className += " GreyText";
      }
      if (noPaddingLeft) {
        className += " NoPaddingLeft";
      }
      if (buttonCell) {
        className += " ButtonCell";
      }
      if (placeholder) {
        className += " Placeholder";
      }
      if (overflowVisible) {
        className += " OverflowVisible";
      }
    }
    return className;
  };

  return (
    <div
      css={{ backgroundColor: `${backgroundColour} !important` }}
      className={getCellClassName()}
      title={text == null ? "" : text}
      style={style}
    >
      {text && <span>{text}</span>}
      {children}
    </div>
  );
};

export { Cell };
